import React from 'react';
import {    
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBCardImage
} from 'mdb-react-ui-kit';


const Card = ({name, className, about, img, tokenId, hbarPrice, usdcPrice, quantity, button0, button1, style}) => {
  return (
    <MDBCard className={`${className}`} style={{...style}}>                     
        <MDBCardBody className='text-black'>
            <MDBCardImage fluid className='img-fluid mb-3 rounded' src={img} style={{width: 300}}/>
            <MDBCardTitle>{name}</MDBCardTitle>
              <MDBCardText>{tokenId}</MDBCardText>
              <MDBCardText>{about}{hbarPrice}{usdcPrice}{quantity}</MDBCardText>
              <div>{button0}</div>
              <div className='mt-3'>{button1}</div>
        </MDBCardBody>
    </MDBCard>
  )
}

export default Card;